import { z } from 'zod';

const finite = z.number().finite();
export const PortableNodeSchema = z
  .object({
    id: z.string().min(1),
    type: z.string().min(1),
    position: z.object({ x: finite, y: finite }).passthrough(),
    data: z.record(z.unknown()),
    locked: z.boolean().optional(),
    width: finite.positive().optional(),
    height: finite.positive().optional(),
  })
  .passthrough();

export const PortableEdgeSchema = z
  .object({
    id: z.string().min(1),
    type: z.string().min(1),
    source: z.string().min(1),
    target: z.string().min(1),
    sourceHandle: z.string().optional(),
    targetHandle: z.string().optional(),
    data: z.record(z.unknown()),
  })
  .passthrough();

export const PortableGraphSchema = z
  .object({
    schemaVersion: z.number().int().positive(),
    nodes: z.array(PortableNodeSchema),
    edges: z.array(PortableEdgeSchema),
    viewport: z.object({ x: finite, y: finite, zoom: finite.positive() }).passthrough(),
  })
  .passthrough();
